import AvatarGeometryRenderer from '../avatarGeometryRenderer'

export default function createGeometryManager({
  getCanvas,
  getAvatarRig,
  getAvatarLayers,
  getSettings,
  getCurrentAvatarSrc,
  getGeometryAssetsVersion,
  getDebug,
  getRuntimeState,
  setMeshOutputs,
  setResourceManager
} = {}) {
  let geometryRenderer = null
  let geometryAppliedVersion = -1
  let geometryAppliedKey = ''

  const ensure = () => {
    const canvas = getCanvas()
    const settings = getSettings()
    const avatarRig = getAvatarRig()
    const avatarLayers = getAvatarLayers()
    const currentAvatarSrc = getCurrentAvatarSrc()
    const geometryAssetsVersion = getGeometryAssetsVersion()

    if (!geometryRenderer) {
      geometryRenderer = new AvatarGeometryRenderer({
        width: canvas.width,
        height: canvas.height,
        onDebug: settings?.debugLogs && getDebug ? getDebug() : null
      })
      try {
        if (typeof setResourceManager === 'function') setResourceManager(geometryRenderer)
      } catch {}
      // provide initial runtime if available
      try {
        if (typeof getRuntimeState === 'function') geometryRenderer.setRuntime(getRuntimeState())
      } catch {}
    } else {
      geometryRenderer.setSize(canvas.width, canvas.height)
      try {
        if (typeof setResourceManager === 'function') setResourceManager(geometryRenderer)
      } catch {}
      try {
        if (typeof setMeshOutputs === 'function')
          geometryRenderer.setMeshOutputCallback(setMeshOutputs)
      } catch {}
      try {
        if (typeof getRuntimeState === 'function') geometryRenderer.setRuntime(getRuntimeState())
      } catch {}
    }

    if (!avatarRig || !avatarLayers) {
      try {
        if (typeof setMeshOutputs === 'function')
          geometryRenderer.setMeshOutputCallback(setMeshOutputs)
      } catch {}
      if (typeof geometryRenderer.clearAvatarLayers === 'function') {
        geometryRenderer.clearAvatarLayers()
      }
      geometryAppliedVersion = -1
      geometryAppliedKey = ''
      return geometryRenderer
    }

    if (avatarRig && avatarLayers) {
      const faceUsesEyeCutout =
        getSettings()?.layerVisibility?.avatarEyes !== false && !!avatarLayers.faceNoIrisCanvas
      const geometryAvatarLayers =
        faceUsesEyeCutout && avatarLayers.faceNoIrisCanvas
          ? { ...avatarLayers, faceCanvas: avatarLayers.faceNoIrisCanvas }
          : avatarLayers
      const assetKey = `${currentAvatarSrc || 'none'}:${getSettings()?.layerVisibility?.avatarHair ? 'hair' : 'nohair'}:${faceUsesEyeCutout ? 'eyes-cut' : 'eyes-full'}`
      if (geometryAppliedVersion === geometryAssetsVersion && geometryAppliedKey === assetKey) {
        return geometryRenderer
      }
      geometryRenderer.setAvatarLayers({
        avatarRig,
        avatarLayers: geometryAvatarLayers,
        assetKey
      })
      try {
        if (typeof getRuntimeState === 'function') geometryRenderer.setRuntime(getRuntimeState())
      } catch {}
      geometryAppliedVersion = geometryAssetsVersion
      geometryAppliedKey = assetKey
    }
    try {
      if (typeof setMeshOutputs === 'function')
        geometryRenderer.setMeshOutputCallback(setMeshOutputs)
    } catch {}
    return geometryRenderer
  }

  const resetApplied = () => {
    geometryAppliedVersion = -1
    geometryAppliedKey = ''
  }

  const getRenderer = () => geometryRenderer

  return { ensure, resetApplied, getRenderer }
}
